/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_PublicInputs */

const en_fw_pub_public = /** @type {(inputs: Fw_Pub_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List it in the public gallery`)
};

const id_fw_pub_public = /** @type {(inputs: Fw_Pub_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan di galeri publik`)
};

/**
* | output |
* | --- |
* | "List it in the public gallery" |
*
* @param {Fw_Pub_PublicInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_public = /** @type {((inputs?: Fw_Pub_PublicInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_PublicInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_public(inputs)
	return en_fw_pub_public(inputs)
});